'use client';

import { authStore } from '@wwe-portal/web/providers/stores/auth-store';
import { sendGTMEvent } from './gtm-helper';
import { MenuItemData } from '@wwe-portal/ui/layout/app/left-sidebar/menu';

export const sendForumBtnClickEvent = (isLeftSideBar?: boolean) => {
  const userId = authStore.getState().currentUser?.userId;
  sendGTMEvent({
    category: isLeftSideBar ? 'Left Sidebar' : 'Dashboard',
    action: userId
      ? `wwe-champions-forum/clicked/by-${userId}`
      : `wwe-champions-forum/clicked`,
    event: isLeftSideBar
      ? 'left_side_bar_wwe_champions_forum_button_clicked'
      : 'dashboard_wwe_champions_forum_button_clicked',
  });
};

export const sendMenuClickEvent = (item: MenuItemData) => {
  const userId = authStore.getState().currentUser?.userId;
  sendGTMEvent({
    category: 'Left Sidebar',
    event: 'left_sidebar_item_clicked',
    action: userId ? `/${item.id}/clicked/by-${userId}` : `/${item.id}/clicked`,
  });
};

export const sendStoreClickEvent = (section: string, os: string) => {
  const userId = authStore.getState().currentUser?.userId;
  sendGTMEvent({
    category: section,
    event: 'store_market_clicked',
    action: userId
      ? `/${os}-install/clicked/by-${userId}`
      : `/${os}-install/clicked`,
  });
};
